import React from 'react';

export const DataHook = 'bottom-placeholder';

export class BottomPlaceholder extends React.Component {
  public render(): JSX.Element {
    return <div data-hook={DataHook} />;
  }
}
